import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Spinner, Form, InputGroup, Button } from 'react-bootstrap';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { FaSearch } from 'react-icons/fa';
import './Community.css';
import ThreadCard from './shared/ThreadCard';

export default function CommunitySearch() {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q') || '';
  const navigate = useNavigate();

  const [searchInput, setSearchInput] = useState(query);
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const performSearch = async () => {
      if (!query || query.length < 2) return;
      
      try {
        setLoading(true);
        const res = await fetch(`${process.env.REACT_APP_BASE_URL || ''}/api/community/search?q=${encodeURIComponent(query)}`);
        const data = await res.json();
        
        if (data.success) {
          setResults(data.results);
        }
      } catch (error) {
        console.error("Search error", error);
      } finally {
        setLoading(false);
      }
    };

    performSearch();
  }, [query]);

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchInput.trim().length >= 2) {
      navigate(`/community/search?q=${encodeURIComponent(searchInput)}`);
    }
  };

  return (
    <div className="community-container">
      <Container>
        <Row className="mb-5">
          <Col lg={8} className="mx-auto text-center">
            <h1 className="text-white mb-4">Search Community</h1>
            <Form onSubmit={handleSearch}>
              <InputGroup size="lg" className="shadow">
                <Form.Control
                  placeholder="Search discussions, tags..."
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                  className="bg-dark text-white border-secondary"
                  autoFocus
                />
                <Button variant="warning" type="submit">
                  <FaSearch /> Search
                </Button>
              </InputGroup>
            </Form>
          </Col>
        </Row>

        <Row>
          <Col lg={8} className="mx-auto">
            {query && (
              <div className="mb-4 text-muted">
                Showing results for: <strong className="text-white">"{query}"</strong>
              </div>
            )}
            
            {loading ? (
              <div className="text-center py-5">
                <Spinner animation="border" variant="warning" />
              </div>
            ) : query.length < 2 ? (
              <div className="text-center py-5 text-muted">
                Please enter at least 2 characters to search.
              </div>
            ) : results.length > 0 ? (
              <div className="search-results">
                {results.map(thread => (
                  <ThreadCard key={thread.id} thread={thread} />
                ))}
              </div>
            ) : (
              <div className="community-card text-center py-5">
                <h4 className="text-muted mb-3">No results found</h4>
                <p className="text-muted mb-0">Try different keywords or check your spelling.</p>
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
}
